import { render, staticRenderFns } from "./ProductsDescriptionTextField.vue?vue&type=template&id=69adc06e"
import script from "./ProductsDescriptionTextField.vue?vue&type=script&lang=ts"
export * from "./ProductsDescriptionTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports